window.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.matchMedia({
    "(min-width: 750px)": function () {
      const boxes = document.querySelectorAll(".cosma-service-box");

      boxes.forEach((box, index) => {
        if (index === boxes.length - 1) {
          gsap.set(box, { opacity: 1, scale: 1 });
        } else {
          gsap.timeline({
            scrollTrigger: {
              trigger: box,
              start: "top top",
              end: "bottom top",
              scrub: true,
              pin: true,
              pinSpacing: false,
            }
          }).fromTo(
            box,
            { opacity: 1, scale: 1 },
            { opacity: 0, scale: 0.8, ease: "none" }
          );
        }
      });
    },

    "(max-width: 749px)": function () {
      gsap.set(".cosma-service-box", { clearProps: "all" });
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }
  });
});



/* ===============================
   Dessert Dropdown
================================ */

document.addEventListener("DOMContentLoaded", function () {

    const addonSelect = document.getElementById("addon-select");
    const dessertWrapper = document.getElementById("dessert-wrapper");

    if (!addonSelect || !dessertWrapper) return;

    function toggleDessertDropdown() {

        const selectedOption =
            addonSelect.options[addonSelect.selectedIndex];

        if (
            selectedOption &&
            selectedOption.dataset.type === "dessert"
        ) {

            dessertWrapper.style.display = "block";

        } else {

            dessertWrapper.style.display = "none";

            const dessertSelect =
                document.getElementById("dessert-select");

            if (dessertSelect) {
                dessertSelect.selectedIndex = 0;
            }

        }

    }

    addonSelect.addEventListener("change", toggleDessertDropdown);

    toggleDessertDropdown();

});



/* ===============================
   Subtotal
================================ */

document.addEventListener("DOMContentLoaded", () => {

    function updateSubtotal() {

        const subtotal =
            document.getElementById("subtotal-value");

        if (!subtotal) return;

        const addonSelect =
            document.getElementById("addon-select");

        const dessertSelect =
            document.getElementById("dessert-select");

        const qtyInput =
            document.querySelector('[name="quantity"]');

        const basePrice =
            parseInt(subtotal.dataset.unitPrice || 0);

        const qty =
            parseInt(qtyInput?.value || 1);

        let addonPrice = 0;

        if (addonSelect && addonSelect.value) {

            const selectedOption =
                addonSelect.options[addonSelect.selectedIndex];

            if (selectedOption.dataset.type === "dessert") {

                if (dessertSelect) {

                    addonPrice = parseInt(
                        dessertSelect.options[
                            dessertSelect.selectedIndex
                        ].dataset.price || 0
                    );

                }

            } else {

                addonPrice = parseInt(
                    selectedOption.dataset.price || 0
                );

            }

        }

        const total =
            (basePrice + addonPrice) * qty;

        subtotal.innerHTML =
            Shopify.formatMoney(
                total,
                DT_THEME.moneyFormat
            );

    }

    document.addEventListener("change", function (e) {

        if (

            e.target.matches("#addon-select") ||
            e.target.matches("#dessert-select") ||
            e.target.matches('[name="quantity"]') ||
            e.target.closest("variant-radios") ||
            e.target.closest("variant-selects")

        ) {

            setTimeout(updateSubtotal, 100);

        }

    });

    updateSubtotal();

});



document.addEventListener('DOMContentLoaded', function () {
  const addonSelect = document.querySelector('#addon-select'); // Replace with your actual select ID

  if (addonSelect) {
    addonSelect.querySelectorAll('option').forEach(option => {
      option.textContent = option.textContent.replace(/\s*\(Add-on\)/g, '');
    });
  }
});